export default __webpack_public_path__ + "static/img_wave_03-b343a27d8083b3059eaf9242e681ae1e.png";